import { StateCreator } from 'zustand'
import { KeywordType } from '@/shared/types'
import { CampaignCreationState } from '../state'

export interface Step5Slice {
    keywords: KeywordType[]
    setKeywords: (
        keywords: KeywordType[] | ((prev: KeywordType[]) => KeywordType[])
    ) => void
}

export const createStep5Slice: StateCreator<
    CampaignCreationState,
    [],
    [],
    Step5Slice
> = (set) => ({
    keywords: [],
    setKeywords: (keywords) =>
        set((state) => ({
            keywords:
                typeof keywords === 'function'
                    ? keywords(state.keywords)
                    : keywords,
        })),
})
